export default "__VITE_ASSET___xwn76bF__"